import React from 'react'
import { useTranslation } from 'react-i18next'

import { type Route } from '@/components/Tabs/Tabs'
import BasicLayout from '@/components/common/BasicLayout/BasicLayout'
import { useFeatureFlag } from '@/hooks/useFeatureFlag'
import useSemesters from '@/queries/useSemesters'

const AbsencesView = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation('absences2')
  const { data: semesters } = useSemesters()

  const enabledAbsenceRequests = useFeatureFlag(
    'IS_ABSENCE_REQUESTS_MODULE_ENABLED'
  )

  const routes: Route[] = [
    {
      title: t('navigation.all'),
      link: {
        to: '/absences/all',
        search: {
          semester: semesters?.currentSemester.id
        }
      }
    },
    {
      title: t('navigation.absences-request'),
      link: {
        to: '/absences/absences-requests'
      },
      hidden: !enabledAbsenceRequests
    }
  ]

  return (
    <BasicLayout
      header={t('header.absences')}
      routes={routes}
      moduleName={t('header.academics', { ns: 'common' })}
      breadcrumbs={[{ title: t('header.absences'), to: '/absences' }]}
    >
      {children}
    </BasicLayout>
  )
}
export default AbsencesView
